export default __webpack_public_path__ + "static/media/close.0b77d870.svg";